import { getCookie } from "../utils/cookie-service";

const companyId = getCookie("hrms-companyId");
const employeeId = getCookie("hrms-employeeId");

export const API_ENDPOINT = {
  admin: {
    login: "/login",
    freezeMonth: "/attendance/days/freeze",
    freezeMonthList: "/attendance/days/freeze-list",
  },

  ess: {
    login: "/login",
    leave: {
      managerApprovalLeaveRequestList: "/leave/request",
      managerApprovalLeaveRequestAdd: "/leave/request/leave-request-action",
      empLeaveRequestList: "/leave/application",
      leaveApprove: `leave/request`,
      leaveStatistic: `leave/statistic`,
      leaveTypeList: `company/${companyId}/leave-type`,
      leaveTypeListAdminGet: `leave/get-employee-leave-type`,
      leaveTypeListUser: `leave/get-employee-leave-type`,
    },
    employee: {
      employeeListReports: "employee",
    },
    attendance: {
      punch: "attendance/punch",
      punchStatus: "attendance/punch-status",
      attendanceDetailByDays: "/attendance/days",
      attendanceDetailByMonths: "/attendance/months",
      leaveRequest: "/leave/application",
      leaveBalance: "/ess/leave-balance",
      calendarView: "ess/attendance/calendar-view",
      attendanceAnalytics: "ess/attendance/analytics",
      regularizationAttandance: "attendance/regularization",
      missedPunchApproverUpdate: "attendance/regularization-action",
      missedPunchList: "attendance/regularization",
      missedPunchApproverAdd: "attendance/regularization",
      missedPunchApproverList: "attendance/regularization",
      missedPunchApproveAll: "attendance/regularization/action",
    },
    assets: {
      assetsRequest: `/asset-request`,
      updateAssetsRequest: `/asset-request`,
      deleteAssetsRequest: `/asset-request`,
      myAssets: `/asset-request`,
      managerList: `/asset/reports/requests`,
      managerApprovalAssetsAdd: `/asset/requests/action`,
      assetsGroupList: `company/${companyId}/asset-group`,
    },
    // essExitProcess
    essExitProcess: {
      myApplicationExitList: `employee`,
      myApplicationExitAdd: "/exitess/addExitNewApplication",
      employeeMasterData: "/employee",
      myApplicationEmployeeData: "/exitess/getExitNewApplication/21",
      exitApprovalApplicationAdd: "/exitess/addExitApprovalApplication",
      ExitClearanceEmail: "/exitess/addExitEssEmployeeClearance",
      ExitCleranceList: "exitess/exitNewApplicationList/1",
      ExitSupervisorClearance: "exitess/addExitEssApprovalClearance",

      //Revoke process exit
      revokeAdd: "revoke/addExitRevokeApplication",
      //Ess Employee Exit Approval
      // Exit approval Part
      ExitApprovalApplicationadd: "",
      ExitApprovalApplicationList: "",
      ExitApprovalApplicationUpdate: "",
    },
    // essReimburshmentProcess
    essReimburshmentProcess: {
      travelTypeList: "reimbursement/getTravelType",
      travelRequisitionAdd: "essReimbursement/addTravelRequistion",
      travelRequisitionUpdate: "essReimbursement/updateTravelRequistion",
      travelRequisitionList: "essReimbursement/getEmployeeTravelRequisition",
      travelRequisitionDelete: "essReimbursement/deleteTravelRequistion",
      travelDetailsAdd: "essReimbursement/addTravelDetails",
      travelDetailsUpdate: "essReimbursement/addTravelDetails",
      travelDetailsUpdate: "essReimbursement/updateTravelDetails",
      travelDetailsList: "essReimbursement/travelDetailsList",
      travelDetailsgetById: "essReimbursement/deleteTravelDetails",
      travelDetailsDelete: "essReimbursement/deleteTravelDetails",
      accomodationAdd: "essReimbursement/addAccommodation",
      accomodationUpdate: "essReimbursement/updateAccommodation",
      accomodationDelete: "essReimbursement/deleteAccommodation",
      accomodationList: "essReimbursement/accommodationList",
      accomodationgetById: "essReimbursement/getAccommodationDetails",
      uploadDocumentAdd: "essReimbursement/addDocument",
      uploadDocumentUpdate: "essReimbursement/updateDocument",
      uploadDocumentDelete: "essReimbursement/deleteDocument",
      uploadDocumentList: "essReimbursement/documentList",
      uploadDocumentgetById: "essReimbursement/getDocumentDetails",
      claimLtaAdd: "reimbursement/addReimbursementClaimLta",
      otherLtaAdd: "reimbursement/addReimbursementOhterLta",
    },
  },

  company: {
    companyList: "/company",
    companyDetail: "/company",
    companyAdd: "/company",
    companyUpdate: "/company",
    companyDelete: "/company",
    company: "/company",
    missPunchSetting: `company/${companyId}/miss-punch-setting`,
    //statutory
    statutory: `company/${companyId}/statutory`,
    //document
    addDocument: `company/${companyId}/document`,
    documentList: `company/${companyId}/document-all`,
    detailDocument: `company/${companyId}/document`,
    updateDocument: `company/${companyId}/document`,
    deleteDocument: `company/${companyId}/document-delete`,
    //setting
    addSetting: `company/${companyId}/setting`,
    detailSetting: `company/${companyId}/setting`,
  },

  cron: {
    cronManual: "/cron/mannual-cron-execution",
  },

  master: {
    stateList: `/state-list`,
    countryList: `/country-list`,
    masterListCompanyId: "masterlist/masterList",
    masterCompanyInformationAdd: "/company",
    masterCompanyGetByIdList: `/company`,
    masterCompanyInformationUpdate: `/company/${companyId}`,
    masterCompanyInformationgetById: "/company",
    masterCompanyDocumentAdd: `/company/${companyId}/document`,
    masterCompanyDocumentList: "/company",
    masterCompanyDocumentDelete: `company/${companyId}/document`,
    masterCompanyDocumentUpdate: `company/${companyId}/document`,
    masterCompanyStatutoryAdd: `/company/${companyId}/statutory`,
    masterCompanyStatutoryUpdate: `/company/${companyId}/statutory`,
    masterCompanyStatutoryById: `/company/${companyId}`,
    masterCompanySetting: `company/${companyId}/setting`,
    masterCompanySettingUpdate: `company/${companyId}/setting`,
    masterCompanySettingById: `company/${companyId}/setting`,
    getGrade: "master/getGrade",
    gradeList: `/company/${companyId}/grade`,
    addGrade: `/company/${companyId}/grade`,
    updateGrade: `/company/${companyId}/grade`,
    deleteGrade: `/company/${companyId}/grade-delete`,
    //deprtment
    dependantDepartmentList: `/company/${companyId}/department-list`,
    departmentList: `/company/${companyId}/department-all`,
    departmentDetail: `/company/${companyId}/department`,
    addDepartment: `/company/${companyId}/department`,
    updateDepartment: `/company/${companyId}/department-update`,
    deleteDepartment: `/company/${companyId}/department-delete`,
    //designation
    dependantDesignationList: `/company/${companyId}/designation-list`,
    designationList: `/company/${companyId}/designation-all`,
    designationDetail: `/company/${companyId}/designation`,
    addDesignation: `/company/${companyId}/designation`,
    updateDesignation: `/company/${companyId}/designation-update`,
    deleteDesignation: `/company/${companyId}/designation-delete`,
    // division
    dependantDivisionList: `/company/${companyId}/division-list`,
    divisionList: `/company/${companyId}/division-all`,
    getDivision: `/company/${companyId}/division`,
    addDivision: `/company/${companyId}/division`,
    updateDivision: `/company/${companyId}/division-update`,
    deleteDivision: `/company/${companyId}/division-delete`,
    projectList: `/company/${companyId}/project`,
    getProject: "master/getProject",
    addProject: `/company/${companyId}/project`,
    updateProject: `/company/${companyId}/project`,
    deleteProject: `/company/${companyId}/project-delete`,
    bankList: `/company/${companyId}/bank`,
    getBank: "master/getBank",
    addBank: `/company/${companyId}/bank`,
    updateBank: `/company/${companyId}/bank`,
    deleteBank: `/company/${companyId}/bank-delete`,
    qualificationTypeList: `/company/${companyId}/qualification-type`,
    addQualification: `/company/${companyId}/qualification`,
    qualificationList: `/company/${companyId}/qualification`,
    updateQualification: `/company/${companyId}/qualification`,
    deleteQualification: `/company/${companyId}/qualification-delete`,
    addqualificationType: `/company/${companyId}/qualification-type`,
    updateQualificationType: `/company/${companyId}/qualification-type`,
    deleteQualificationType: `/company/${companyId}/qualification-type`,
    prefixNameList: "master/prefixNameList",
    addPrefixName: "master/addPrefixName",
    updatePrefixName: "master/updatePrefixName",
    getPrefixName: "master/getPrefixName",
    deletePrefixName: "master/deletePrefixName",
    payrollCycleList: "master/payrollCycleList",
    getPayrollCycle: "master/getPayrollCycle",
    addPayrollCycle: "master/addPayrollCycle",
    updatePayrollCycle: "master/updatePayrollCycle",
    deletePayrollCycle: "master/deletePayrollCycle",
    idProofList: "master/idProofList",
    getIdProof: "master/getIdProof",
    addIdProof: "master/addIdProof",
    updateIdProof: "master/updateIdProof",
    deleteIdProof: "master/deleteIdProof",

    //document
    documentTypeListAll: `/company/${companyId}/document-type-all`,
    documentTypeList: `/company/${companyId}/document-type-list`,
    addDocumentType: `/company/${companyId}/document-type`,
    updateDocumentType: `/company/${companyId}/document-type`,
    documentTypeDetail: `/company/${companyId}/document-type`,
    deleteDocumentType: `/company/${companyId}/document-type-delete`,

    branchList: `/company/${companyId}/branch`,
    branchListAll: `/company/${companyId}/branches-list-all`,
    getBranch: "master/getBranch",
    addBranch: `/company/${companyId}/branch`,
    editBranchList: `/company/${companyId}/branch`,
    updateBranch: `/company/${companyId}/branch`,
    deleteBranch: `/company/${companyId}/branch-delete`,
    companyList: "/company",
    getCompany: "company",
    addCompany: "company/addCompany",
    updateCompany: "company/updateCompany",
    deleteCompany: "company/deleteCompany",
    getCategory: "master/getCategory",
    addCategory: `/company/${companyId}/category`,
    categoryList: `/company/${companyId}/category`,
    updateCategory: `/company/${companyId}/category`,
    deleteCategory: `/company/${companyId}/category-delete`,
    //emp code category
    empCodecategoryListAll: `/company/${companyId}/employee-code-category-all`,
    empCodecategoryList: `/company/${companyId}/employee-code-category-list`,
    addEmpCodeCategory: `/company/${companyId}/employee-code-category`,
    updateEmpCodeCategory: `/company/${companyId}/employee-code-category-update`,
    deleteEmpCodeCategory: `/company/${companyId}/employee-code-delete`,
    detailEmpCodeCategory: `/company/${companyId}/employee-code-category`,
    getCostCenter: "master/getCostCenter",
    costCenterList: `/company/${companyId}/cost-center`,
    addCostCenter: `/company/${companyId}/cost-center`,
    updateCostCenter: `/company/${companyId}/cost-center`,
    deleteCostCenter: `/company/${companyId}/cost-center-delete`,
    getSkill: "master/getSkill",
    skillList: `/company/${companyId}/skill`,
    addSkill: `/company/${companyId}/skill`,
    updateSkill: `/company/${companyId}/skill`,
    deleteSkill: `/company/${companyId}/skill-delete`,
    getBonus: "master/getBonus",
    bonusList: `/company/${companyId}/bonus`,
    addBonus: `/company/${companyId}/bonus`,
    bonusWagesList: `/company/${companyId}/government-bonus-wages-list`,
    bonusWagesAdd: `/company/${companyId}/government-bonus-wages`,
    bonusWagesDelete: `/company/${companyId}/government-bonus-wages-list/delete`,
    updateBonus: `/company/${companyId}/bonus`,
    deleteBonus: `/company/${companyId}/bonus`,
    bonusCategoryList: `/company/${companyId}/bonus-category`,
    addBonusCategory: `/company/${companyId}/bonus-category`,
    updateBonusCategory: `/company/${companyId}/bonus-category`,
    deleteBonusCategory: `/company/${companyId}/bonus-category`,
    bonusStatutory: `/company/${companyId}/bonus-statutory`,
    bonusStatutoryList: `/company/${companyId}/bonus-statutory`,
    addBonusStatutory: `/company/${companyId}/bonus-statutory`,
    updateBonusStatutory: `/company/${companyId}/bonus-statutory`,
    deleteBonusStatutory: `/company/${companyId}/bonus-statutory`,

    // location
    locationList: `/company/${companyId}/location-all`,
    locationAdd: `/company/${companyId}/location`,
    locationDetail: `company/${companyId}/location`,
    locationUpdate: `/company/${companyId}/location-update`,
    locationDelete: `/company/${companyId}/location-delete`,
    dependantLocationList: `/company/${companyId}/location-list`,

    // currency
    currencyList: `/currency`,
    currencyAdd: `/currency`,
    currencyGetById: `/currency`,
    currencyUpdate: `/currency`,
    currencyDelete: `/currency`,

    //cron
    cronList: `/cron`,
    cronAdd: `/cron`,
    cronUpdate: `/cron`,
    crondelete: `/cron`,

    // gender
    genderList: `company/${companyId}/gender`,
    genderAdd: `company/${companyId}/gender`,
    genderGetById: `company/${companyId}/gender`,
    genderUpdate: `company/${companyId}/gender`,
    genderDelete: `company/${companyId}/gender`,

    // attandance source
    sourceList: `company`,
    sourceAdd: `company/${companyId}/attendance-source`,
    sourceUpdate: `company/${companyId}/attendance-source`,
    sourceDelete: `company/${companyId}/attendance-source`,

    // branch attendance Setting
    branchAttendaceSettingAdd: `company/${companyId}/branch-attendance`,
    branchAttendaceSettingUpdate: `company/${companyId}/branch-attendance`,
    branchAttendaceSettingDelete: `company/${companyId}/branch-attendance`,
    branchAttendaceSettingGetById: `company/${companyId}/branch-attendance`,

    //mail
    thirdPartyMailSetting: `company/${companyId}/smtp-credential`,
    thirdPartyMailList: `company/${companyId}/smtp-credential`,

    //attendance setting
    attendanceSettingList: `company/${companyId}/company-attendance-setting-all`,
    addAttendanceSetting: `company/${companyId}/company-attendance-setting`,
    updateAttendanceSetting: `company/${companyId}/company-attendance-setting`,
    detailAttendanceSetting: `company/${companyId}/company-attendance-setting-detail`,
    deleteAttendanceSetting: `company/${companyId}/company-attendance-setting-delete`,
    //miss Punch setting
    missPunchSettingList: `company/${companyId}/miss-punch-setting-all`,
    addMissPunchSetting: `company/${companyId}/miss-punch-setting`,
    updateMissPunchSetting: `company/${companyId}/miss-punch-setting`,
    detailMissPunchSetting: `company/${companyId}/miss-punch-setting-detail`,
    deleteMissPunchSetting: `company/${companyId}/miss-punch-setting-delete`,
  },

  employee: {
    employeeList: "employee",
    employeeListAll: `/company/${companyId}/employee-list-all`,
    employeeForList: `/company/${companyId}/employee-all`,
    empCodeCategory: `/company/${companyId}/get-emp-code-by-category`,
    employeeByCode: "reimbursement/getEmployeeDetails",
    addEmployee: "employee",
    updateEmployee: "employee",
    getEmployee: `employee`,
    deleteEmployee: `employee`,
    getEmployeeWorkExperienceList: `/employee`,
    addEmployeeWorkExperience: `/employee`,
    updateEmployeeWorkExperience: `/employee`,
    deleteEmployeeWorkExperience: `/employee`,
    getEmployeeSkills: `/employee`,
    addEmployeeSkill: `/employee`,
    updateEmployeeSkill: `/employee`,
    deleteEmployeeSkill: `/employee`,
    employeeQualificationList: `/employee`,
    addEmployeeQualification: `/employee`,
    updateEmployeeQualification: `/employee`,
    deleteEmployeeQualification: `/employee`,
    empAddress: `employee`,
    personalDetail: `employee`,
    governmentDetail: `employee`,
    governmentDetailList: `employee/${employeeId}/government-detail`,
    getEmployeeHobbies: `/employee`,
    addEmployeeHobby: `/employee`,
    updateEmployeeHobby: `/employee`,
    deleteEmployeeHobby: `/employee`,
    getEmployeeAchievements: `/employee`,
    addEmployeeAchievement: `/employee`,
    updateEmployeeAchievement: `/employee`,
    deleteEmployeeAchievement: `/employee`,
    getEmployeeContactDetails: "employee/getEmployeeContactDetails",
    addEmployeeContactDetails: "employee/addEmployeeContactDetails",
    updateEmployeeContactDetail: "employee/updateEmployeeContactDetails",
    getEmployeeDependentList: `employee`,
    getEmployeeDependentListEmpId: "employee/getEmployeeDependentList",
    getEmployeeDependent: `employee/${employeeId}/dependant`,
    addEmployeeDependent: `employee`,
    updateEmployeeDependent: `employee`,
    deleteEmployeeDependent: `employee`,
    employeeDocumentAdd: `employee`,
    employeeDocumentUpdate: `employee`,
    statutoryList: `employee`,
    employeeStatutoryAdd: `employee`,
    employeeStatutoryGetById: `employee/${employeeId}/statutory`,
    employeeStatutoryUpdate: `employee/${employeeId}/statutory`,
    employeeMicsAllList: `employee`,
    employeeMicsDelete: `employee`,

    // employee Medical
    employeeMedicalAdd: `employee`,
    employeeMedicalUpdate: `employee`,
    employeeMedicalDelete: `employee`,
    employeeMedicalInsuranceList: `employee`,

    // Insurance Plan
    InsurancePlanList: `company/${companyId}/insurance-plan`,
    InsurancePlanAdd: `company/${companyId}/insurance-plan`,
    InsurancePlanGetById: `company/${companyId}/insurance-plan`,
    InsurancePlanUpdate: `company/${companyId}/insurance-plan`,
    InsurancePlanDelete: `company/${companyId}/insurance-plan`,

    // Insurance Company
    InsuranceCompanyList: `company/${companyId}/insurance-company`,
    InsuranceCompanyAdd: `company/${companyId}/insurance-company`,
    InsuranceCompanyGetById: `company/${companyId}/insurance-company`,
    InsuranceCompanyUpdate: `company/${companyId}/insurance-company`,
    InsuranceCompanyDelete: `company/${companyId}/insurance-company`,

    // Email
    EmailList: `employee`,
    EmailAdd: `employee`,
    EmailDelete: `employee`,
    getEmail: `employee`,
    EmailGetById: `employee`,
    EmailUpdate: `employee`,
    EmailDelete: `employee`,

    // Contact Details
    ContactList: `employee`,
    ContactAdd: `employee`,
    deleteContact: `employee`,
    getContact: `employee`,
    ContactGetById: `employee/${employeeId}/contact`,
    ContactUpdate: `employee/${employeeId}/contact`,
    ContactDelete: `employee/${employeeId}/contact`,
    //confirmation
    confirmation: `/company/${companyId}/employee-confirmation`,
  },

  attendance: {
    leaveTypeList: `company/${companyId}/leave-type`,
    getLeaveType: `company/${companyId}/leave-type`,
    addLeaveType: `company/${companyId}/leave-type`,
    updateLeaveType: `company/${companyId}/leave-type`,
    deleteLeaveType: `company/${companyId}/leave-type`,
    leaveList: `company/${companyId}/leave-type`,
    compOfList: `leave/compoff-details`,
    getLeave: "attendance/getLeave",
    addLeaveSetting: `company/${companyId}/leave-type-setting`,
    updateLeaveSetting: `company/${companyId}/leave-type-setting`,
    deleteLeaveSetting: `company/${companyId}/leave-type-setting`,
    listLeaveSetting: `company/${companyId}/leave-type-setting`,
    getByIdLeaveSetting: `company/${companyId}/leave-type-setting`,
    leaveStatistic: `leave/statistic`,
    updateLeave: "attendance/updateLeave",
    deleteLeave: "attendance/deleteLeave",
    getHoliday: "attendance/getHoliday",
    addHoliday: "attendance/addHoliday",
    attendanceDayListAll: "attendance/days",
    uploadAttendance: "/attendance/punch/import",
    updateAttendance: "/attendance/months",
    getAttendanceStatus: "/attendance/get-attendance-status",
    // leave part

    approveRejectLeaves: "attendance/approveRejectLeaves",
    empAttendanceList: "/attendance/days",
    empLeaveAnalyticsList: "/attendance/empLeaveAnalyticsList",
    empLeaveBalanceList1: "/attendance/empLeaveBalanceList1",
    empLeaveBalance: "/attendance/empLeaveBalance",
    empLeaveList: "/attendance/empLeaveList",
    addManualLeaveRequest: "/attendance/addManualLeaveRequest",
    getallAttendanceList: "/attendance/getallAttendanceList",
    attendanceLogList: "/employee",
    attendanceLogAdd: "/employee",
    attendanceLogUpdate: "/employee",
    attendanceLogDelete: "/employee",
    attendanceDaysUpdate: "/attendance/days",
  },

  leave: {
    leaveStatistic: "/leave/statistic",
    adminLeaveRequestList: "/leave/request",
    adminLeaveRequestList: "/leave/get-request-by-admin",
  },

  holiday: {
    holidayType: `company/${companyId}/holiday-type`,
    holidayTypeList: `company/${companyId}/holiday-type`,
    holidayTypeDelete: `company/${companyId}/holiday-type`,
    holidayTypeUpdate: `company/${companyId}/holiday-type`,
    holidayAdd: `company/${companyId}/holiday`,
    holidayUpdate: `company/${companyId}/holiday`,
    holidayList: `company/${companyId}/holiday`,
    holidayDelete: `company/${companyId}/holiday`,
    holidayGetById: `company/${companyId}/holiday`,
  },

  shift: {
    list: `company`,
    shiftList: `company/${companyId}/shift`,
    getShift: `company/${companyId}/shift`,
    addShift: `company/${companyId}/shift`,
    updateShift: `company/${companyId}/shift`,
    deleteShift: `company/${companyId}/shift`,

    addShiftAssiged: "attendance/addEmployeeAssignShift",

    /* new as per nilansh api */
    shiftAssigedList: `employee/${employeeId}/shift`,
    assignShiftAdd: `company/${companyId}/shift-assign`,
    assignShiftUpdate: `company/${companyId}/shift-assign`,
  },

  email: {
    emailTemplateAdd: `company/${companyId}/notification-template`,
    emailTemplateUpdate: `company/${companyId}/notification-template`,
    emailTemplateList: `company/${companyId}/notification-template`,
    emailTemplateDelete: `company/${companyId}/notification-template`,
    //notification user
    emailNotification: `company/${companyId}/notification-user`,
  },

  assets: {
    assetsGroupList: `company/${companyId}/asset-group`,
    addAssetsGroup: `company/${companyId}/asset-group`,
    updateAssetsGroup: `company/${companyId}/asset-group`,
    deleteAssetsGroup: `company/${companyId}/asset-group`,

    assetsMasterList: `company/${companyId}/asset`,
    addAsset: `company/${companyId}/asset`,
    updateAsset: `company/${companyId}/asset`,
    deleteAsset: `company/${companyId}/asset`,
    getAsset: `company/${companyId}/asset`,

    // admin request list api
    assetsRequestList: "asset/reports/requests",
    assetsAssign: `company/${companyId}/asset-movement`,
    assetsMovementList: `company/${companyId}/asset-movement`,
    addAssetMovement: `company/${companyId}/asset-movement`,
    assetMovement: "company",
    assetsRequisitionList: "asset/assetRequisitionList",
    assets: "company",
  },

  exit: {
    // master list
    exitTypeList: `company/${companyId}/exit-type`,
    exitDelete: `company/${companyId}/exit-type`,
    exitPost: `company/${companyId}/exit-type`,
    exitUpdate: `company/${companyId}/exit-type`,
    //exit Resignation
    exitResignationAdd: `employee`,
    exitResignationUpdate: `employee`,
    exitResignationGetDetails: `employee`,
    exitResignationList: `employee`,
    exitfnfListbyId: `employee`,
    exitfnfDetails: `employee`,

    //exit-fnf
    exitfnfAdd: "employee",
    exitfnfUpdate: `employee`,
    exitfnfDelete: `employee`,

    // clearence list
    exitClearanceDepartmentList: "/approval/exitApprovalList",
    exitClearanceDepartmentPost: "/approval/addExitApproval",
    exitClearanceDepartmentDelete: "/approval/deleteExitApprovalGroup",
    exitClearanceDepartmentUpdate: "/approval/updateExitApprovalGroup",
    // notice list
    noticePeriodList: "noticeperiod/exitNoitcePeriodList",
    noticePeriodDelete: "noticeperiod/deleteExitNoitcePeriod",
    noticePeriodUpdate: "noticeperiod/updateExitNoitcePeriod",
    noticePeriodAdd: "noticeperiod/addExitNoitcePeriod",
    // InterViewIn list
    interViewInchargeList: "interview/interviewGroupList",
    interViewInchargeDelete: "interview/deleteInterviewGroup",
    interViewInchargeUpdate: "interview/updateInterviewGroup",
    interViewInchargeAdd: "interview/addInterviewGroup",
    // Clearance Descripition
    clearanceDepartmentList: "exitdepartment/exitDepartmentClearanceList",
    clearanceDepartmentDelete: "exitdepartment/deleteExitDepartmentClearance",
    clearanceDepartmentUpdate: "exitdepartment/updateExitDepartmentClearance",
    clearanceDepartmentAdd: "exitdepartment/addExitDepartmentClearance",
    // Questions Part
    questionsList: "exitquestion/exitTypeQuestionList",
    questionsDelete: "exitquestion/deleteExitTypeQuestion",
    questionsUpdate: "exitquestion/updateExitTypeQuestion",
    questionsAdd: "exitquestion/addExitTypeQuestion",
    questionsHeadingAdd: "exitType/addExitHeading",
    questionsHeadingUpdate: "exitType/updateExitHeading",
    questionsHeadingList: "exitType/exitHeading",
    questionsHeadingDelete: "exitType/deleteExitHeading",
    questionsTypeAdd: "exitType/addExitQuestion",
    questionsTypeUpdate: "exitType/updateExitQuestion",
    questionsTypeList: "exitType/exitQuestion",
    questionsTypeDelete: "exitType/deleteExitQuestion",
  },

  // payroll
  payroll: {
    payrollMasterListCompanyId: "payroll/ctcpayrollMasterList",
    payrollMasterHeaderItemList: "payroll/empIncremenTArrearEmployeeFilterList",
    //type of head master
    typeOfHead: `/company/${companyId}/salary-head-payment-type`,
    // salary head
    payrollSalaryHeadList: `/company/${companyId}/salary-head`,
    salaryHeadDelete: `/company/${companyId}/salary-head`,
    salaryHeadPost: `/company/${companyId}/salary-head`,
    salaryHeadUpdate: `/company/${companyId}/salary-head`,
    payrollSalaryHeadId: `/company/${companyId}/salary-head`,
    //salary process
    salaryProcess: "/salary/process-pay",
    // Deducation head
    payrollDeductionHeadList: `/company/${companyId}/salary-head`,
    payrollDeductionHeadId: "payroll/getDeductionHead",
    DeductionHeadDelete: "payroll/deleteDeductionHead",
    DeductionHeadPost: "payroll/addDeductionHead",
    DeductionHeadUpdate: "payroll/updateDeductionHead",

    // Other head
    payrollOtherHeadList: `/company/${companyId}/salary-head`,
    payrollOtherHeadDelete: "payroll/deleteOtherHead",
    payrollOtherHeadAdd: "payroll/addOtherHead",
    payrollOtherHeadUpdate: "payroll/updateOtherHead",
    payrollOtherHeadId: "payroll/getOtherHead",

    // Gournal Head
    payrollJournalList: "payroll/journalVoucherList",
    payrollJournalDelete: "payroll/deleteJournalVoucher",
    payrollJournalAdd: "payroll/addJournalVoucher",
    payrollJournalUpdate: "payroll/updateJournalVoucher",

    // OverTime
    OvertimeList: `/company/${companyId}/salary-over-time-calculation`,
    OvertimeAdd: `/company/${companyId}/salary-over-time-calculation`,
    OvertimeUpdate: `/company/${companyId}/salary-over-time-calculation`,
    OvertimeDelete: `/company/${companyId}/salary-over-time-calculation`,

    // OtUploadAttandence
    OtAttendanceList: "payroll/otAttendanceAllList",
    OtAttendanceAdd: "payroll/addOtAttendance",
    OtAttendanceUpdate: "payroll/updateOtAttendance",
    OtAttendanceDelete: "payroll/deleteOtAttendance",

    // LWF
    LwfList: `/company/${companyId}/salary-lwf`,
    LwfAdd: `/company/${companyId}/salary-lwf`,
    lwfByIdDetail: `/company/${companyId}/salary-lwf`,
    LwfUpdate: `/company/${companyId}/salary-lwf`,
    LwfDelete: `/company/${companyId}/salary-lwf`,

    // Professional Tax
    ProfessionalTaxList: `/company/${companyId}/salary-pt`,
    ProfessionalTaxAdd: `/company/${companyId}/salary-pt`,
    ProfessionalTaxUpdate: `/company/${companyId}/salary-pt`,
    ProfessionalTaxDelete: `/company/${companyId}/salary-pt`,
    ProfessionalTaxId: `/company/${companyId}/salary-pt`,

    // ctc component setting
    CtcComponentList: `/company/${companyId}/salary-component`,
    CtcComponentAdd: `/company/${companyId}/salary-component`,
    CtcGetDetails: `/company/${companyId}/salary-component`,
    CtcComponentUpdate: `/company/${companyId}/salary-component`,
    CtcComponentDelete: `/company/${companyId}/salary-component`,
    CtcComponentAddId: "payroll/getCtcStructure",
    CtcComponentAddCtc: "payroll/ctcCalculation",
    CtcComponentAddCtcCalculated: "payroll/addSalaryStructureCtc",
    CtcComponentAddCtcSaveData: "payroll/getSalaryStructureCtc",

    // Leave Encashment
    LeaveEncashmentList: `/company/${companyId}/salary-leave-encashment`,
    LeaveEncashmentAdd: `/company/${companyId}/salary-leave-encashment`,
    LeaveEncashmentUpdate: `/company/${companyId}/salary-leave-encashment`,
    LeaveEncashmentDelete: `/company/${companyId}/salary-leave-encashment`,

    // salarystructur
    salaryStructureAdd: "/employee",
    salaryStructureCalculate: "/employee",
    salaryStructureList: "/employee",
    salaryStructure: "/employee",
    salaryStructureDelete: "/employee",
    SalaryStructureHeadList: "payroll/salaryStructureHeadList",
    SalaryStructureHeadAdd: "payroll/addSalaryStructureHead",
    SalaryStructureHeadUpdate: "payroll/updateSalaryStructure",
    SalaryStructureHeadDelete: "payroll/deleteSalaryStructure",

    //salaryStructureCtc
    SalaryStructureCtc: "payroll/salaryStructureList",
    SalaryStructureCtcAdd: "payroll/addSalaryStructureHead",
    SalaryStructureCtcUpdate: "payroll/updateSalaryStructureHead",
    SalaryStructureCtcDelete: "payroll/deleteSalaryStructureHead",

    //increment arrear
    IncrementArrear: `employee`,
    calculateDays: "/arrear/calculate-lwp-days",
    IncrementArrearUpdate: "payroll/updateSalaryIncrement",
    IncrementArrearList: "payroll/salaryIncrementList",
    IncrementArrearList: "payroll/salaryArrearList",
    IncrementArrearById: "payroll/getSalaryIncrement",
    IncrementArrearDel: "payroll/deleteSalaryArrear",

    // BonusCalculation
    BonusCalculationList: `company/${companyId}/salary-bonus-calculation`,
    BonusCalculationAdd: `company/${companyId}/salary-bonus-calculation`,
    BonusCalculationDelete: `company/${companyId}/salary-bonus-calculation`,
    BonusCalculationUpdate: `company/${companyId}/salary-bonus-calculation`,
    BonusCalculationGetId: `company/${companyId}/salary-bonus-calculation`,

    // Lwp Arrear
    LwpArrearList: "payroll/salaryArrearlwpList",
    LwpArrearAdd: "payroll/addSalaryArrearlwp",
    LwpArrearUpdate: "payroll/updateSalaryArrearlwp",
    LwpArrearGetId: "payroll/getSalaryArrearlwp",
    LwpArrearDelete: "payroll/deleteSalaryArrearlwp",
    // Lwp Arrear
    OtherArrearList: "payroll/salaryArrearotherList",
    OtherArrearAdd: "payroll/addSalaryArrearother",
    OtherArrearUpdate: "payroll/updateSalaryArrearother",
    OtherArrearGetId: "payroll/getSalaryArrearother",
    OtherArrearDelete: "payroll/deleteSalaryArrearother",

    //Gratuity
    GratuityList: `company/${companyId}/salary-gratuity-calculation`,
    GratuityAdd: `company/${companyId}/salary-gratuity-calculation`,
    GratuityUpdate: `company/${companyId}/salary-gratuity-calculation`,
    GratuityDelete: `company/${companyId}/salary-gratuity-calculation`,
    // Promotion
    promotion: "/employee/employment-detail-change",

    PromotionList: "/employee/employment-detail-change",
    PromotionGetDetails: "/employee/employment-detail-changes",
    PromotionUpdate: "payroll/updatePromotionTransfer",
    PromotionDelete: "payroll/deletePromotionTransfer",
    PromotionGetId: "payroll/getPromotionTransfer",

    // Salary Increment
    SalaryIncrement: `employee`,
    EmployeeIncrementList: `employee`,
    EmployeeIncrement: `/employee`,

    EmployeeIncrementByEmpId: "payroll/getSalaryStructureEmpList",
    EmployeeIncrementUpdate: "payroll/updateSalaryIncrement",
    EmployeeIncrementDelete: "payroll/deleteSalaryIncrement",
    EmployeeIncrementGetId: "payroll/getSalaryIncrement",
    EmployeeIncrementByIdView: "payroll/getSalaryIncrementEmpList",
    EmployeeIncrementDaysAdd: "payroll/employeeDays",
  },

  reimbursement: {
    travelTypeList: "reimbursement/getTravelTyPeList",
    travelAdd: "reimbursement/addTravelPolicy",
    travelPolicyList: "reimbursement/travelPolicyList",
    travelPolicyDelete: "reimbursement/deleteTravelPolicy",
    approvalMatrixList: "reimbursement/approalMatrixList",
    approvalMatrixAdd: "reimbursement/addApproalMatrix",
    approvalMatrixDelete: "reimbursement/deleteApproalMatrix",
    approvalMatrixUpdate: "reimbursement/updateApproalMatrix",
    approvalMatrixFilterAdd: "reimbursement/addApproalFilterMatrix",
    settingFaceList: "reimbursement/reimbursementSettingList",
    settingFaceAdd: "reimbursement/addReimbursementSetting",
    processAdminAdd: "reimbursement/addReimbursement",
    processAdminUpdate: "reimbursement/updateReimbursement",
    processAdminDelete: "reimbursement/deleteReimbursement",
    processAdminList: "reimbursement/reimbursementList",
    processAdminGetById: "reimbursement/getReimbursementAdd",
  },

  user: {
    adminRole: "user/admin-role",
    essRole: "user/ess-role",
    admin: "user/admin",
    ess: "user/ess",
    userList: "/user",
    userAccess: "/user/settings",
    // show all permissison list
    permissions: "permission",
    roleCreate: "role",
    roleList: "role",
    deleteRole: "role",
    updateRole: "role",

    // assign Request
    userList: "user",
    assignRequest: "role/user-assign",
  },
};
